import {
  Bell,
  FileText,
  FolderKanban,
  Image as ImageIcon,
  LayoutDashboard,
  Palette,
  Settings,
  UserPlus,
  Vote,
} from 'lucide-react';

import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';

const topics = [
  {
    icon: LayoutDashboard,
    title: 'Dashboard',
    body: 'A quick overview of everything: how many projects are running, what is open for voting right now, and how many people are on the list.',
  },
  {
    icon: FolderKanban,
    title: 'Projects',
    body: 'Create a project and move it through its stages: Coming Soon, Voting, Winner Selected, Production and finally Archive. You can run several projects at the same time.',
  },
  {
    icon: Palette,
    title: 'Artists',
    body: 'Add the artists taking part and give each one a short bio, a discipline and a profile photo chosen from your media library.',
  },
  {
    icon: FileText,
    title: 'Proposals',
    body: 'Each project has a set of competing proposals. Add them, write the description and update their status as the project moves along.',
  },
  {
    icon: ImageIcon,
    title: 'Media',
    body: 'Upload images, video or documents once and reuse them anywhere. You can pick a hero image and a gallery for each project or proposal.',
  },
  {
    icon: Vote,
    title: 'Voting & votes',
    body: 'Open a voting period, watch the results come in, then close it and select the winning proposal. The Votes page lists every vote that was cast.',
  },
  {
    icon: UserPlus,
    title: 'Subscribers & emails',
    body: 'The mailing list, including people who joined the jury early and emails left after voting. Export the whole list as a spreadsheet whenever you need it.',
  },
  {
    icon: Bell,
    title: 'Notifications',
    body: 'See what your team has changed recently. Items are marked as read just for you, so everyone can keep their own place.',
  },
  {
    icon: Settings,
    title: 'Team & settings',
    body: 'Invite other admins, set the default length of a voting period, and connect notifications so the team hears about important activity.',
  },
];

/** Protected help page for the client admins: plain-language guidance. */
export function HelpPage() {
  return (
    <div className="mx-auto max-w-4xl space-y-8">
      <p className="text-muted-foreground text-sm leading-6">
        Welcome to the NeedfulThings dashboard. This page is a quick guide to what each section does
        and how to find your way around. It is all about managing the projects, no technical setup
        needed.
      </p>

      <div className="grid gap-4 sm:grid-cols-2">
        {topics.map((topic) => (
          <Card key={topic.title}>
            <CardHeader>
              <div className="flex items-center gap-2">
                <topic.icon className="size-4 text-muted-foreground" />
                <CardTitle className="text-base">{topic.title}</CardTitle>
              </div>
            </CardHeader>
            <CardContent>
              <p className="text-muted-foreground text-sm leading-6">{topic.body}</p>
            </CardContent>
          </Card>
        ))}
      </div>

      <Card>
        <CardHeader>
          <CardTitle className="text-base">Need a hand?</CardTitle>
          <CardDescription>
            Anything unclear, or need access for someone new? Just email{' '}
            <a
              href="mailto:luiz@moureau.dev"
              className="text-foreground underline underline-offset-4"
            >
              luiz@moureau.dev
            </a>{' '}
            or through WhatsApp.
          </CardDescription>
        </CardHeader>
      </Card>
    </div>
  );
}
